import { Affix, Button, Layout } from 'antd';
import AppFooter from '../AppFooter';
import AppHeader from '../AppHeader';
import Authed from '../_authed';
import ContextLoadingChecker from '../ContextLoadingChecker';
import InfoPanel from './InfoPanel';
import { MenuOutlined } from '@ant-design/icons';
import { ReportsAccessProvider } from '../../lib/ReportsAccessContext';
import { ReportsIcon } from '../../components/images/NavIcons';
import SideNavigation from './SideNavigation';
import { useState } from 'react';
const currentSection = {
  icon: <ReportsIcon />,
  name: 'Reports'
};
export default (({
  children
}) => {
  const [isOpen, setIsOpen] = useState();
  return <Authed>
      <Affix>
        <AppHeader extraLeft={typeof isOpen === 'boolean' && <Button className="header-menu-button" type="link" icon={<MenuOutlined />} shape="circle" size="large" onClick={() => setIsOpen(!isOpen)} />} currentSection={currentSection} />
      </Affix>
      <ContextLoadingChecker>
        <ReportsAccessProvider>
          <SideNavigation isOpen={isOpen} setIsOpen={setIsOpen} />
          <InfoPanel isOpen={isOpen} setIsOpen={setIsOpen} />
          <Layout.Content style={{
          margin: 10,
          marginTop: 0,
          overflow: 'initial'
        }} children={children} />
        </ReportsAccessProvider>
      </ContextLoadingChecker>
      <AppFooter />
    </Authed>;
});